import {
  GET_SURVEYSCORE,
  GET_SURVEYSCORE_SUCCESS,
  GET_SURVEYSCORE_FAIL,
  DELETE_SURVEYSCORE,
  DELETE_SURVEYSCORE_SUCCESS,
  DELETE_SURVEYSCORE_FAIL,
  UPDATE_SURVEYSCORE,
  UPDATE_SURVEYSCORE_SUCCESS,
  UPDATE_SURVEYSCORE_FAIL,
  ADD_NEW_SURVEYSCORE,
  ADD_SURVEYSCORE_SUCCESS,
  ADD_SURVEYSCORE_FAIL,
  SURVEYSCORE_LOADING,
  SURVEYSCORE_RESET,
  SURVEYSCORE_RESET_CREATE,
} from "./actionType";

export const resetSurveyScoreState = (actionType) => ({
  type: SURVEYSCORE_RESET,
  payload: { actionType },
});

export const resetSurveyScoreCreateState = (actionType) => ({
  type: SURVEYSCORE_RESET_CREATE,
  payload: { actionType },
});

export const getSurveyScoreSuccess = (actionType, data) => ({
  type: GET_SURVEYSCORE_SUCCESS,
  payload: { actionType, data },
});

export const getSurveyScoreFail = (actionType, error) => ({
  type: GET_SURVEYSCORE_FAIL,
  payload: { actionType, error },
});

export const getSurveyScore = (data) => ({
  type: GET_SURVEYSCORE,
  payload: data,
});

export const getSurveyScoreLoading = () => ({
  type: SURVEYSCORE_LOADING,
});

export const deleteSurveyScore = (data) => ({
  type: DELETE_SURVEYSCORE,
  payload: data,
});

export const deleteSurveyScoreSuccess = (data) => ({
  type: DELETE_SURVEYSCORE_SUCCESS,
  payload: data,
});

export const deleteSurveyScoreFail = (error) => ({
  type: DELETE_SURVEYSCORE_FAIL,
  payload: error,
});

export const updateSurveyScore = (data) => ({
  type: UPDATE_SURVEYSCORE,
  payload: data,
});

export const updateSurveyScoreFail = (error) => ({
  type: UPDATE_SURVEYSCORE_FAIL,
  payload: error,
});

export const updateSurveyScoreSuccess = (data) => ({
  type: UPDATE_SURVEYSCORE_SUCCESS,
  payload: data,
});

export const addNewSurveyScore = (data) => ({
  type: ADD_NEW_SURVEYSCORE,
  payload: data,
});

export const addSurveyScoreSuccess = (data) => ({
  type: ADD_SURVEYSCORE_SUCCESS,
  payload: data,
});

export const addSurveyScoreFail = (error) => ({
  type: ADD_SURVEYSCORE_FAIL,
  payload: error,
});
